module.exports = __webpack_public_path__ + "img/classify_1.cf67a4b3.png";